import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { AuthenticationService } from '../../../_Services/user/authentication.service';
import { Router } from '@angular/router';
import { UserModel } from '../../../_Models/user/user.model';
//import { MenuItemModel } from '../../../_Models/user/menuItem.model';
import { HrService } from '../../../_Services/hr/hr.service';
import { Permission, Url, UserType } from '../../common/static-data-common';
import{DataServiceService}from "../../../_Services/common/data-service-service.service";
import { UtilityService } from 'src/app/_Services/common/utility.service';
import { PermissionService } from 'src/app/_Services/common/permission.service';
import { MenuItemModel } from 'src/app/_Models/user/menuitem.model';
import { DefaultUrlRequest, RightType, UserRightTypeAccess } from 'src/app/_Models/common/common.model';
import { CustomerService } from 'src/app/_Services/customer/customer.service';


export const broadCastChannel = new BroadcastChannel('authentication');
@Component({
	selector: 'app-drawer-menu',
	templateUrl: './drawer-menu.component.html',
	styleUrls: ['./drawer-menu.component.scss']
})
export class DrawerMenuComponent {
	public User: UserModel;
	public identityBaseurl : string;
	photourl: string
	_userTypeId;
	usergender: string;
	_internalusertype = UserType.InternalUser;
	permission : any = Permission;
	isChangePasswordAccess:boolean=false;
	userRightTypeAccessList: Array<UserRightTypeAccess>;
	selectedRightType: UserRightTypeAccess;
	showRightTypeList: boolean;
	rightTypeList: Array<RightType>;
	selectedId: number;
	rightdata : any = [];
	constructor(private authenticationService: AuthenticationService,   private customerService: CustomerService,
		@Inject('IDENTITYSERVER_URL') identityBaseUrl: string, 
		private router: Router, private service: HrService,private ds: DataServiceService, public utility: UtilityService,private permissionSerive:PermissionService,
      ) {
		// Load user
		if (localStorage.getItem('currentUser')) {
          this.User = JSON.parse(localStorage.getItem('currentUser'));
		}
		this.identityBaseurl = identityBaseUrl;
		this.isChangePasswordAccess = this.permissionSerive.isAnyGranted([Permission.Change_Password_List])
		this._userTypeId = this.User.usertype;
		this.photourl = './assets/images/user-default.svg';
		this.userRightTypeAccessList = this.User.packageFeatures.map((x) => {
			let userAccess = new UserRightTypeAccess();
			userAccess.id = x.id;
			userAccess.name = x.name;
			userAccess.rightTypeFileName = x.iconPath;
			return userAccess;
		  });
		//this.GetUserDetails();
		// Takeing default rightType as first one from the list becouse we have feature load on langauge type so using hardcoded name is an issue.
		this.selectedRightType = this.userRightTypeAccessList[0];
		this.rightdata = this.User.rightsDB.filter(x => x.applicationId == this.selectedRightType.id);
	}
	geturl(item: MenuItemModel) {
		return "/" +  item.path;
	}
	@HostListener('click', ['$event']) onMouseEnter(event) {
		if (event.target.tagName == 'A') {
			if (event.target.nextSibling == null || event.target.href!="")  {
				this.closeDrawer();
			}
		}
	}
	// function to open child menu in drawer
	openChild(event) {
		event.target.classList.toggle('active');
		event.target.firstElementChild.classList.toggle('active');
		event.target.nextElementSibling.classList.toggle('active');
	}

	// function to close the drawer
	closeDrawer() {
		this.ds.changeToggleDrawer(false);
		(<HTMLElement>document.querySelector('.main-wrapper')).classList.remove('drawer-active');
		(<HTMLElement>document.querySelector('.drawer-menu-container')).classList.remove('active');
	}
	redirectToProfilePage() {
		this.router.navigate(["/" +  Url.UserProfile + this.User.id]);
	  }
	public signOut() {
		broadCastChannel.postMessage('Logout');
	}
	setBlobFile(blob) {
		if (blob) {
			var reader = new FileReader();
			reader.readAsDataURL(blob); // read file as data url
			reader.onload = (event) => { // called once readAsDataURL is completed
				this.photourl = (<FileReaderEventTarget>event.target).result;
			}
		}
	}
	GetMenuParentId(menuid) {
		localStorage.setItem("_activemenuid", menuid)
	}
	// GetUserDetails() {
	// 	if (this._userTypeId == this._internalusertype) {
	// 	  this.service.GetGender()
	// 		.subscribe((res) => {
	// 		  if (res && res.result == 1) {
	// 			this.usergender = res.gender;
	// 			if (res.isPhotovailable)
	// 			  this.GetPhoto();
	// 		  }
	// 		  else {
	// 			this.photourl = './assets/images/user-default.svg';
	// 		  }
	// 		},
	// 		  error => console.log(error)
	// 		);

	// 	}
	// 	else {
	// 	  this.photourl = './assets/images/user-default.svg';
	// 	}
	//   }
	// GetPhoto(){
	// 	if (this._userTypeId == this._internalusertype) {
	// 		this.service.getPicture(this.User.staffId).subscribe(data => {
	// 			this.setBlobFile(data);
	// 		}, error => {
	// 			this.SetPhoto();
	// 		});
	// 	}
	// }
	SetPhoto() {
		if (this._userTypeId == this._internalusertype) {
			if (this.photourl && this.usergender == 'M')
				this.photourl = 'assets/images/male.jpg';
			else if (this.photourl && this.usergender == 'F')
				this.photourl = 'assets/images/female.jpg';
			return this.photourl;
		}
		
	}



	//assign the selected rightType and navigates to the selected menu
	changeRightType(rightType :UserRightTypeAccess) {
		this.rightdata = [];
		this.showRightTypeList = !this.showRightTypeList;
		this.rightdata = this.User.rightsDB.filter(x => x.applicationId == rightType.id);

		if (rightType) {
			this.selectedRightType = rightType;
			//update the user data based on the selected rightType
			if (rightType.id) {
				localStorage.setItem('rightType', JSON.stringify(rightType.id));
				this.User = this.authenticationService.getCurrentUser();
				this.RedirectWithServiceAccess(rightType.id);
				
			}
		}

	
	}

	//toggle the rightType list dropdown data
	toggleRightTypeData() {
		this.showRightTypeList = !this.showRightTypeList
	}
	
	RedirectWithServiceAccess(id :number) {
		
		this.selectedId = id;
		//set the selected service
		localStorage.setItem('service', JSON.stringify(id));
		//update the current user and assign back to user object
		this.User = this.authenticationService.getCurrentUser();
		//redirect to page specific to the selected service
	
		let RoleType = this.User.roles.map(x => { return x.roleType; });
		let userType = this.User.usertype;
	
		let defaultUrlRequest = new DefaultUrlRequest();
		defaultUrlRequest.featureId = id;
		defaultUrlRequest.RoleTypes = RoleType;
		defaultUrlRequest.UserType = userType;
	
		this.customerService.GetDefaultFeatureUrl(defaultUrlRequest).subscribe(res => {
		  if (res?.defaultUrl) {
			const finalUrl = res.defaultUrl;
			this.router.navigate([finalUrl]);
		  } else {
			console.log("default URL is null", res);
		  }
		},
		  error => {
			console.log(error);
		  });
	  }
}
interface FileReaderEventTarget extends EventTarget {
	result: string
}
interface FileReaderEvent extends Event {
	target: FileReaderEventTarget;
	getMessage(): string;
}

